import * as RT from './Routing'

  const env = process.env.NODE_ENV

  export const API_SERVER_URL = env === 'production' ? 'https://api.circrew.fun' : 'http://localhost:3800'
  
  // export const API_SERVER_URL = 'https://api.circrew.fun'

  export const FRONT_APP_URL = env === 'production' ? 'https://circrew.fun' : 'http://localhost:3000'
  
  export const STRIPE_API_PUBLISH_KEY = env === 'production' ? 'pk_live_NOCYnLcjOnhfu8RobvEWnONT' : 'pk_test_LVeUiP1LLCTQv2PoYYDPFvF5'

// export const API_SERVER_URL = 'https://dev-api.circrew.fun' // dev


// export const FRONT_APP_URL = 'https://dev.circrew.fun' //dev


export const FILE_SIZE_LIMIT = 10485760

// export const GOOGLE_CLIENT_ID = '762564267236-rg9tpmjr9o8uca1p81ogtkjvgjarer93.apps.googleusercontent.com'
export const GOOGLE_CLIENT_ID = '762564267236-nlchfcer2330gq7n1g64cd6nhug1jk59.apps.googleusercontent.com'

export const FACEBOOK_SIGN_IN_URL = API_SERVER_URL + '/api/v1/users/sign_in_with_facebook'
export const TWITTER_TOKEN_URL = API_SERVER_URL + '/api/v1/users/twitter_token'
export const TWITTER_API_URL = 'https://api.twitter.com/oauth/authenticate'
export const TWITTER_SIGN_IN_URL = API_SERVER_URL + '/api/v1/users/sign_in_with_twitter'
export const TWITTER_AUTH_URL = API_SERVER_URL + '/auth/twitter'
export const TWITTER_SERVER_CALLBACK_URL = API_SERVER_URL + '/auth/twitter/callback'

export const GOOGLE_AUTH_URL = API_SERVER_URL + '/auth/google'
export const GOOGLE_SERVER_CALLBACK_URL = API_SERVER_URL + '/auth/google/callback'

export const FACEBOOK_AUTH_URL = API_SERVER_URL + '/auth/facebook'
export const FACEBOOK_SERVER_CALLBACK_URL = API_SERVER_URL + '/auth/facebook/callback'

export const GOOGLE_SIGN_IN_URL = API_SERVER_URL + '/api/v1/users/sign_in_with_google'

export const API_SIGN_IN_CHECK_URL = API_SERVER_URL + '/api/v1/users/me'

export const GOOGLE_API_URL = `https://accounts.google.com/o/oauth2/auth?client_id=${GOOGLE_CLIENT_ID}&response_type=code&scope=email%20profile&redirect_uri=${FRONT_APP_URL}${RT.GOOGLE_CALLBACK_PATH}&state_token=`

export const USER_FIRST_REGIST_URL = API_SERVER_URL + '/api/v1/users/register';
export const USER_UPDATE_URL = API_SERVER_URL + '/api/v1/users';
export const USER_CARD_REGIST_URL = API_SERVER_URL + '/api/v1/cards';
export const USER_CARDS_URL = API_SERVER_URL + '/api/v1/cards';
export const USER_CARD_DELETE_URL = API_SERVER_URL + '/api/v1/cards/:id';

export const USER_ACCOUNT_INDEX_URL = API_SERVER_URL + '/api/v1/accounts'
export const USER_ACCOUNT_SHOW_URL = API_SERVER_URL + '/api/v1/accounts/:id'
export const USER_ACCOUNT_CREATE_URL = API_SERVER_URL + '/api/v1/accounts'
export const USER_ACCOUNT_FIRST_OR_CREATE_URL = API_SERVER_URL + '/api/v1/accounts'
export const USER_ACCOUNT_UPDATE_URL = API_SERVER_URL + '/api/v1/accounts/:id'
export const USER_ACCOUNT_VERIFY_URL = API_SERVER_URL + '/api/v1/accounts/:id/verify'
export const USER_ACCOUNT_DESTROY_URL = API_SERVER_URL + '/api/v1/accounts/:id';
export const USER_SHOW_URL = API_SERVER_URL + '/api/v1/users/:id'
export const USER_COMMUNITIES_LIST_URL = API_SERVER_URL + '/api/v1/users/:id/communities';
export const USER_MESSAGE_ROOM_INDEX_URL = API_SERVER_URL + '/api/v1/rooms'
export const USER_MESSAGES_INDEX_URL = API_SERVER_URL + '/api/v1/rooms/:id' // :id は相手ユーザーのid
export const USER_MESSAGES_READ_URL = API_SERVER_URL + '/api/v1/rooms/:id/read' // :id は相手ユーザーのid
export const USER_MESSAGES_CREATE = API_SERVER_URL + '/api/v1/rooms'

export const COMMUNITY_INDEX_URL = API_SERVER_URL + '/api/v1/communities';          // get
export const COMMUNITY_SHOW_URL = API_SERVER_URL + '/api/v1/communities/:id';       // get
export const COMMUNITY_APPLIED_USERS_URL = API_SERVER_URL + '/api/v1/communities/:id/applied'
export const COMMUNITY_USER_APPROVE_URL = API_SERVER_URL + '/api/v1/communities/:id/approve'
export const COMMUNITY_USER_REJECT_URL = API_SERVER_URL + '/api/v1/communities/:id/reject'
export const COMMUNITY_CREATE_URL = API_SERVER_URL + '/api/v1/communities';         // post
export const COMMUNITY_UPDATE_URL = API_SERVER_URL + '/api/v1/communities/:id';     //put
export const COMMUNITY_DESTROY_URL = API_SERVER_URL + '/api/v1/communities/:id';    // delete
export const COMMUNITY_JOIN_URL = API_SERVER_URL + '/api/v1/communities/:id/join';  // post 参加メソッド
export const COMMUNITY_DEFECT_URL = API_SERVER_URL + '/api/v1/communities/:id/defect'; //post 脱退
export const COMMUNITY_BLOCK_URL = API_SERVER_URL + '/api/v1/communities/:id/block';  // post 参加者ブロック
export const COMMUNITY_OWNER_CHANGE_URL = API_SERVER_URL + '/api/v1/communities/:id/owner'

export const POST_CREATE_URL = API_SERVER_URL + '/api/v1/posts'
export const POST_UPDATE_URL = API_SERVER_URL + '/api/v1/posts/:id'
export const POST_DESTROY_URL = API_SERVER_URL + '/api/v1/posts/:id'

export const COMMENT_CREATE_URL = API_SERVER_URL + '/api/v1/comments'
export const COMMENT_UPDATE_URL = API_SERVER_URL + '/api/v1/comments/:id'
export const COMMENT_DESTROY_URL = API_SERVER_URL + '/api/v1/comments/:id'

export const COMMUNITY_TITLE1_MARK = '!--*[title1]*--!'
export const COMMUNITY_TITLE2_MARK = '!--*[title2]*--!'
export const COMMUNITY_TITLE3_MARK = '!--*[title3]*--!'
export const COMMUNITY_BODY1_MARK = '!--*[body1]*--!'
export const COMMUNITY_BODY2_MARK = '!--*[body2]*--!'
export const COMMUNITY_BODY3_MARK = '!--*[body3]*--!'

export const COMMUNITY_TITLE1_MARK_REG = '\\!\\-\\-\\*\\[title1\\]\\*\\-\\-\\!'
export const COMMUNITY_TITLE2_MARK_REG = '\\!\\-\\-\\*\\[title2\\]\\*\\-\\-\\!'
export const COMMUNITY_TITLE3_MARK_REG = '\\!\\-\\-\\*\\[title3\\]\\*\\-\\-\\!'
export const COMMUNITY_BODY1_MARK_REG = '\\!\\-\\-\\*\\[body1\\]\\*\\-\\-\\!'
export const COMMUNITY_BODY2_MARK_REG = '\\!\\-\\-\\*\\[body2\\]\\*\\-\\-\\!'
export const COMMUNITY_BODY3_MARK_REG = '\\!\\-\\-\\*\\[body3\\]\\*\\-\\-\\!'


export const NOTIFICATION_INDEX_URL = API_SERVER_URL + '/api/v1/notifications'
export const NOTIFICATION_UNREAD_URL = API_SERVER_URL + '/api/v1/notifications/unread'
export const NOTIFICATION_READ_URL = API_SERVER_URL + '/api/v1/notifications/read'

// 問い合わせ送信
export const INQUIRY_CREATE_URL = API_SERVER_URL + '/api/v1/contacts'

// カテゴリーマスタ
export const categories = [
  { id: 1, name: "アート" },
  { id: 2, name: "音楽" },
  { id: 3, name: "舞台・パフォーマンス" },
  { id: 4, name: "プロダクト" },
  { id: 5, name: "テクノロジー" },
  { id: 6, name: "ゲーム" },
  { id: 7, name: "フード" },
  { id: 8, name: "ファッション" },
  { id: 9, name: "映像・映画" },
  { id: 10, name: "書籍・雑誌出版" },
  { id: 11, name: "アニメ・漫画" },
  { id: 12, name: "スポーツ" },
  { id: 13, name: "ビジネス" },
  { id: 14, name: "ソーシャルグッド" },
  { id: 15, name: "ビューティー" },
  { id: 16, name: "ヘルスケア" },
  { id: 17, name: "まちづくり" },
  { id: 18, name: "語学" },
  { id: 19, name: "WEB/パソコン" },
  { id: 20, name: "趣味" },
  { id: 21, name: "勉強・資格" },
  { id: 22, name: "エンタメ" },
  { id: 23, name: "その他" }
]
  
// エリアマスタ
export const places = [
  { id: 1, name: "北海道" },
  { id: 2, name: "青森県" },
  { id: 3, name: "岩手県" },
  { id: 4, name: "宮城県" },
  { id: 5, name: "秋田県" },
  { id: 6, name: "山形県" },
  { id: 7, name: "福島県" },
  { id: 8, name: "茨城県" },
  { id: 9, name: "栃木県" },
  { id: 10, name: "群馬県" },
  { id: 11, name: "埼玉県" },
  { id: 12, name: "千葉県" },
  { id: 13, name: "東京都" },
  { id: 14, name: "神奈川県" },
  { id: 15, name: "新潟県" },
  { id: 16, name: "富山県" },
  { id: 17, name: "石川県" },
  { id: 18, name: "福井県" },
  { id: 19, name: "山梨県" },
  { id: 20, name: "長野県" },
  { id: 21, name: "岐阜県" },
  { id: 22, name: "静岡県" },
  { id: 23, name: "愛知県" },
  { id: 24, name: "三重県" },
  { id: 25, name: "滋賀県" },
  { id: 26, name: "京都府" },
  { id: 27, name: "大阪府" },
  { id: 28, name: "兵庫県" },
  { id: 29, name: "奈良県" },
  { id: 30, name: "和歌山県" },
  { id: 31, name: "鳥取県" },
  { id: 32, name: "島根県" },
  { id: 33, name: "岡山県" },
  { id: 34, name: "広島県" },
  { id: 35, name: "山口県" },
  { id: 36, name: "徳島県" },
  { id: 37, name: "香川県" },
  { id: 38, name: "愛媛県" },
  { id: 39, name: "高知県" },
  { id: 40, name: "福岡県" },
  { id: 41, name: "佐賀県" },
  { id: 42, name: "長崎県" },
  { id: 43, name: "熊本県" },
  { id: 44, name: "大分県" },
  { id: 45, name: "宮崎県" },
  { id: 46, name: "鹿児島県" },
  { id: 47, name: "沖縄県" }
]


export const META_TITLE = 'Circrew (サークルー)'
export const META_DESCRIPTION = 'サークルー(circrew)は家でも会社でもない好きでつながる第3のコミュニティサービスです。アート、音楽、スポーツ、ビジネス、趣味など好きなテーマでサークルを立ち上げて仲間を集めてコミュニティを運営しよう。サークル単位でコインや商品チケットを販売でき、第３者に販売できます。月額会員制で入部できる大人のサークルです。忙しいあなたも趣味を副業にしてお金を稼ごう。'



// WEBPACK FOOTER //
// ./src/constants/AppSettings.js